// ====================================================================================
// --- Arquivo: src/utils/modernAlert.js ---
// Descrição: Substitui o alert() nativo do navegador (caixa cinza que trava a tela)
// por avisos elegantes do react-hot-toast, sem precisar alterar cada chamada.
// O tipo do aviso (erro / sucesso / atenção / informação) é inferido pelo texto.
// ====================================================================================
import toast from 'react-hot-toast';

const ERROR_RE = /(erro|error|falh|fail|inválid|invalid|não foi possível|nao foi possivel|não conseguimos|negad|denied|indisponível|expirad|❌)/i;
const SUCCESS_RE = /(sucesso|salv[oa]|conclu[ií]d|enviad[oa]|criad[oa]|atualizad[oa]|copiad[oa]|gerad[oa]|exclu[ií]d|removid[oa]|registrad[oa]|✅|🎉)/i;
const WARNING_RE = /(atenção|atencao|aviso|selecione|preencha|informe|obrigatóri|necessári|por favor|limite|⚠️)/i;

const baseStyle = {
    whiteSpace: 'pre-line',
    maxWidth: 480,
    fontSize: 14,
    lineHeight: 1.45,
    borderRadius: 14,
    padding: '12px 16px',
};

export function showModernAlert(message) {
    const text = message === undefined || message === null ? '' : String(message);
    // Mensagens longas ficam mais tempo na tela
    const duration = Math.min(12000, Math.max(3500, text.length * 60));
    const options = { duration, style: baseStyle };

    if (ERROR_RE.test(text)) return toast.error(text, options);
    if (SUCCESS_RE.test(text)) return toast.success(text, options);
    if (WARNING_RE.test(text)) return toast(text, { ...options, icon: '⚠️' });
    return toast(text, { ...options, icon: 'ℹ️' });
}

export function installModernAlert() {
    if (typeof window === 'undefined' || window.__psmModernAlertInstalled) return;
    const nativeAlert = window.alert ? window.alert.bind(window) : null;
    window.__psmNativeAlert = nativeAlert;
    window.alert = (message) => {
        try {
            showModernAlert(message);
        } catch (e) {
            // Se algo der errado com o toast, volta ao comportamento original
            if (nativeAlert) nativeAlert(message);
        }
    };
    window.__psmModernAlertInstalled = true;
}
